import { ReactElement } from "react";
import { Table } from "react-bootstrap";

export function GenericTable<T extends { id: string|number; }>({ items, columns, emptyMessage }: {
  items: T[];
  columns: {
    width?: string;
    label: string;
    render: (item: T) => ReactElement|string;
  }[];
  emptyMessage: ReactElement;
}) {
  return (

  <Table striped bordered className="table-container">
    <thead>
      <tr className="table-heading">
        { columns.map((column, index) =>
        {
          return <th key={index} style={{ width: column.width }}>{column.label}</th>
        })}
      </tr>
    </thead>
    <tbody>
      {items.length > 0 ? (
        items.map((item) => (
          <tr className="table-row" key={`ResolucionTable-${item.id}`}>
            { columns.map((column, index) =>
            {
              return <td key={index}>{column.render(item)}</td>
            })}
          </tr>
        ))
      ) : (
        <tr>
          <td
            colSpan={columns.length}
            className="text-center table-error-message"
          >
            <p>
              { emptyMessage }
            </p>
          </td>
        </tr>
      )}
    </tbody>
  </Table>
  )
}
